module.exports = __webpack_public_path__ + "static/img/IMG_20241027_170735.43399472.jpg";